import axios from 'axios';
import config from 'commons-vehicle/config/index.js';
import { ConfigsService, HTTPService, TokenService } from '@sm360/widget-commons-core-services';
import { AccountService } from '@sm360/widget-commons-general';

class TradeInsService {
    constructor() {
        this.basePath = `${config.endpoint.tradein}`;
    }

    loadTradeInVehicle() {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const organizationId = ConfigsService.getOrganizationId();
        const organizationUnitId = ConfigsService.getOrganizationUnitId();
        const organizationLocation = ConfigsService.getOrganizationUnitLocation();

        return AccountService.getLoggedAccount()
            .then((account) => {
                const { id: accountId, contactId } = account;
                return TokenService.fetch().then((accessToken) =>
                    axios.get(
                        `${this.basePath}/tradeIn?${[
                            `contactId=${contactId}`,
                            `accountId=${accountId}`,
                            `orgId=${organizationId}`,
                            `orgUnitId=${organizationUnitId}`,
                            `orgLocation=${organizationLocation}`,
                        ].join('&')}`,
                        {
                            headers: {
                                Authorization: `Bearer ${accessToken}`,
                            },
                        }
                    )
                );
            })
            .then((result) => {
                return result.data;
            })
            .catch(() => Promise.resolve(null));
    }

    updateTradeIn(tradeIn) {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const orgId = ConfigsService.getOrganizationId();
        const orgUnitId = ConfigsService.getOrganizationUnitId();
        const orgLocation = ConfigsService.getOrganizationUnitLocation();

        const tradeInToUpdate = {
            ...tradeIn,
            orgId,
            orgUnitId,
            orgLocation,
        };

        return TokenService.fetch()
            .then((accessToken) =>
                axios.put(`${this.basePath}/tradeIn?`, tradeInToUpdate, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            )
            .then((result) => {
                return result.data;
            });
    }

    deleteTradeIn(tradeIn) {
        if (!AccountService.isAuthenticated()) {
            return Promise.reject(HTTPService.formatRejectResponse('user not authenticated'));
        }

        const { tradeId } = tradeIn;
        return TokenService.fetch()
            .then((accessToken) =>
                axios.delete(`${this.basePath}/tradeIn/${tradeId}?`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            )
            .then((result) => {
                return result;
            });
    }
}

export default new TradeInsService();
